import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Divider from '@amzn/meridian/divider';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { setPageProgress } from 'src/store/newJmrPageSlice';
// import { useAppSelector } from 'src/store/store';
// import { JmrPageProgress, TableDataRow } from 'src/utils/jmrUtils';
import { JmrPageProgress, TableDataRow } from 'src/utils/jmrUtils';
import ConfirmModal from 'src/components/shared/confirmModal/confirmModal';
import { ItemPropsDisplay, SectionTitle } from '../common';
import { useAppSelector } from 'src/store/store';

/**
 * Default component
 */
const PlacementSelectionsReview = () => {
  const dispatch = useDispatch();
  const jmrResults = useAppSelector((store) => store.newJmrPage.jmrResults);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Box>
      {/* Header */}
      <SectionTitle label="Job Placements" editButtonOnClick={() => setIsModalOpen(true)} />

      {/* Main Body */}
      <Column spacingInset="400 none 600 none">
        {jmrResults
          .filter((result) => result.isChecked)
          .map((jmrResult, i) => (
            <Box key={i}>
              <PlacementWrapper jmrResult={jmrResult} />
              <Box spacingInset="100" />
            </Box>
          ))}
      </Column>

      {/* Modals */}
      <ConfirmModal
        modalTitle="Leave page"
        modalDescription="Leaving this page will restart your Job Match Results process."
        open={isModalOpen}
        setOpen={() => setIsModalOpen(false)}
        onConfirm={() => dispatch(setPageProgress(JmrPageProgress.JobMatches))}
        width="419px"
      />
    </Box>
  );
};

/**
 * Display a Placement Table
 */
const PlacementWrapper = ({ jmrResult }: { jmrResult: TableDataRow }) => {
  const numConflicts = jmrResult?.conflicts?.length || 0;

  return (
    <Box type="outline" spacingInset="400">
      {/* Label */}
      <Box spacingInset="none none 400 none">
        <Text type="h200">
          {jmrResult.name} | {jmrResult.jobType}
        </Text>
      </Box>

      {/* Table */}
      <Column>
        {/* Shift Code and Hours */}
        <Row alignmentHorizontal="justify">
          <Box width="33%">
            <ItemPropsDisplay index={0} label="Shift" value={jmrResult.shiftCode} />
          </Box>
          <Box width="66%">
            <ItemPropsDisplay index={0} label="Hours Assigned" value={jmrResult.totalHours} />
          </Box>
        </Row>

        {/* Show divider if there are conflicts */}
        {numConflicts ? <Divider /> : null}

        {/* Allocated Tasks */}
        {jmrResult.conflicts?.map((item, i) => (
          <Column key={i}>
            <Row key={i} alignmentHorizontal="start" spacingInset="none none 100 none">
              <Box width="33%">
                <ItemPropsDisplay key={i} index={i + 1} label={'Restriction ' + (i + 1)} value={item.taskName} />
              </Box>
              <Box width="66%">
                <ItemPropsDisplay
                  key={i}
                  index={i + 1.5}
                  label="Modification"
                  value={item.appliedModifications?.map(({ name }) => name).join(', ')}
                />
              </Box>
            </Row>
            {i !== numConflicts - 1 ? <Divider /> : null}
          </Column>
        ))}
      </Column>
    </Box>
  );
};

export default PlacementSelectionsReview;
